import { ReactFlow, Controls, Background, MiniMap } from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import resizeableNode from "./resizeableNode";

const nodeTypes = {
  resizeableNode,
};

function FlowComponent({
  nodes,
  onNodesChange,
  edges,
  onEdgesChange,
  onConnect,
  onNodeDoubleClick,
}: any) {
  return (
    <ReactFlow
      nodeTypes={nodeTypes}
      nodes={nodes}
      onNodesChange={onNodesChange}
      edges={edges}
      onEdgesChange={onEdgesChange}
      onConnect={onConnect}
      onNodeDoubleClick={onNodeDoubleClick}
      fitView
    >
      <Background />
      <MiniMap />
      <Controls />
    </ReactFlow>
  );
}

export default FlowComponent;
